import { Box, Container, Stack, Typography } from "@mui/material"

import { BoltLogo, UberLogo } from "../../../components/PartnerLogos"
import { homeCopy } from "../../../content/homeCopy"

const partners = [
    { name: "Uber", Logo: UberLogo },
    { name: "Bolt", Logo: BoltLogo },
]

const logoSx = {
    height: { xs: 18, md: 22 },
    width: "auto",
    display: "block",
    opacity: 0.92,
}

const TrustStrip = () => {
    return (
        <Box
            component="section"
            sx={{
                py: { xs: 3, md: 4 },
                borderBottom: "1px solid",
                borderColor: "divider",
                background: "#fff",
            }}
        >
            <Container maxWidth="lg">
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={3}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={{ xs: 2, md: 3 }}
                        flexWrap="wrap"
                        justifyContent="center"
                        useFlexGap
                    >
                        <Typography variant="body2" color="text.secondary" fontWeight={600}>
                            Trusted by drivers on
                        </Typography>
                        {partners.map(({ name, Logo }) => (
                            <Logo key={name} sx={logoSx} />
                        ))}
                    </Stack>

                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Box>
                            <Typography variant="body2" fontWeight={700} color="#000435">
                                {homeCopy.trustStrip.title}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {homeCopy.trustStrip.subtitle}
                            </Typography>
                        </Box>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    )
}

export default TrustStrip
